export const SUBSCRIPTION_PLAN_BANNER_TEXTS = {
  reactivateAccount: "Reativar Assinatura",
  retry: "Tentar novamente",
  messages: {
    payment_not_confirmed:
      "Seu acesso será liberado assim que o pagamento for confirmado",
    plan_expired:
      "Seu plano expirou. Renove sua assinatura para continuar utilizando a plataforma.",
    canceled_but_active: (date: string) =>
      `Você cancelou sua assinatura, mas ainda pode aproveitar todos os recursos até ${date}`,
    canceled_but_active_free_reactivation: (date: string) =>
      `Você cancelou sua assinatura, mas ainda pode aproveitar todos os recursos até ${date}. Reative agora, sem custo adicional, e continue usando a Jusfy normalmente.`,
    reactivation_check_failed:
      "Não conseguimos verificar sua assinatura. Tente novamente.",
    reactivation_processing:
      "Estamos processando a reativação da sua assinatura. Isso pode levar alguns minutos.",
  },
} as const;

export const REGULARIZATION_PERIOD_CREDITS_BANNER_TEXTS = {
  message:
    "Não conseguimos confirmar seu pagamento. Regularize sua assinatura para evitar interrupção dos seus benefícios.",
  cta: "Regularizar",
} as const;
